<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getCont, add, del, update, getDetails } from "@/api/system/contraband";

import cTable from "@/base/common/index";
export default {
  name: "contraband",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getCont,
        getDetails,
        del,
        add,
        update
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              contraband_code: [
                {
                  required: true,
                  message: "Code cannot be empty",
                  trigger: "blur"
                },
                {
                  type: "string",
                  min: 3,
                  max: 5,
                  message: "Please enter minimum length 3 and maximum length 5",
                  trigger: "blur"
                }
              ],
              contraband_description: [
                {
                  required: true,
                  message: "Desc cannot be empty",
                  trigger: "blur"
                },
                {
                  type: "string",
                  min: 3,
                  max: 155,
                  message:
                    "Please enter minimum length 3 and maximum length 155",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ contraband_code: 24 }, { contraband_description: 24 }],
          fields: [
            {
              name: () => this.$t("contraband_code"),
              key: "contraband_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("contraband_code");
              }
            },
            {
              name: () => this.$t("contraband_description"),
              key: "contraband_description",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("contraband_description");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 155
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("contraband_code"),
          key: "contraband_code",
          align: "center"
        },
        {
          name: () => this.$t("contraband_description"),
          key: "contraband_description",
          align: "center"
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 156
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 157
              // bind: {
              //   type: "error"
              // }
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
